import { EntityLayout } from '@internal/plugin-medidata-catalog-react';
import { commonContent } from './commonContent';

export const defaultEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {commonContent}
    </EntityLayout.Route>
  </EntityLayout>
);
